import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    DialogTitle,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";
import { useAuthStore } from "../../stores/authStore";
import { useTransaksiStore } from "../../stores/transaksiStore";

interface IModalKonfirmasiLogoutProps {
    open: boolean;
    onClose: () => void;
}

const ModalKonfirmasiLogout = ({
    open,
    onClose,
}: IModalKonfirmasiLogoutProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const logout = useAuthStore((s) => s.logout);
    const isLoading = useAuthStore((s) => s.isLoading);
    const handleReset = useTransaksiStore((s) => s.handleReset);

    const handleKeluar = () => {
        handleReset();
        logout();
        onClose();
    };

    return (
        <>
            <Dialog
                maxWidth="xs"
                fullWidth={true}
                fullScreen={isPhoneScreen}
                open={open}
                onClose={onClose}
                PaperProps={{
                    sx: {
                        borderRadius: 1,
                    },
                }}
            >
                <DialogTitle>Keluar?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Anda yakin ingin keluar dari aplikasi?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: 2 }}>
                    
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        Tidak
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleKeluar}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        Keluar
                    </Button>
                </DialogActions>
            </Dialog>
            <LoadingOverlay open={isLoading} />
        </>
    );
};

export default ModalKonfirmasiLogout;
